import ToggleableText from 'components/base/ToggleableText';
import styled from 'styled-components';

const StyledSelectedCounterToggler = styled.div`
  display: flex;
`;

const SelectedCounterToggler = ({ count, text, isActive, onClick }) => {
  return (
    <StyledSelectedCounterToggler>
      <ToggleableText
        color={isActive ? 'dodgerBlue' : 'shuttleGray'}
        size='large'
        onClick={onClick}
        isActive={isActive}
      >
        {text}
      </ToggleableText>
    </StyledSelectedCounterToggler>
  );
};

export default SelectedCounterToggler;
